export enum RejectionDSAType {
        DeNovo = 0,
        Persistent = 1
}